export const isValidRcs = (rcs: string = ""): boolean => {
    return /^\d{9}$/.test(rcs);
  };